import axios from './auth'

const BASE_URL = `${process.env.VUE_APP_API_OPS_BASE_URL}/project-pfa`

export const actions = {
  async uploadProjectPfa({ commit }, { project_contract_id, file }) {
    const url = `${BASE_URL}/${project_contract_id}/upload`
    const method = 'post'
    const headers = { 'Content-Type': 'multipart/form-data' }
    const data = new FormData()
    data.append('file', file)
    const config = { url, method, data, headers }
    try {
      const response = await axios(config)
      return { status: 'success', data: response.data }
    } catch (e) {
      return { status: 'error', data: e.response?.data || e }
    }
  },
}

export default { actions }
